import React from 'react';

export default class ButtonPlano extends React.Component {
  render(){
    const block = this.props.valor === '0,00' ? null : (
      <div>
        <p className='button-plano__price'>{this.props.valor}</p>
        <p className='button-plano__name'>{this.props.periodo}</p>
      </div>
    );

    return(
      <li className='item-button-plano'>
        <a
          className={`button-plano ${this.props.ativo ? 'button-plano--ativo' : ''}`}
          href='#'
          onClick={this.props.onClick}
        >
          <div className="pure-g">
            <div className="pure-u-md-3-5 pure-u-1">
              <div className='button-plano__inner'>
                <p className='button-plano__title'>{this.props.title}</p>
                <p className='button-plano__desc'>{this.props.subtitle}</p>
              </div>
            </div>
            <div className="pure-u-md-2-5 pure-u-1">
              {block}
            </div>
          </div>
        </a>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/classes/pagamento/ButtonPlano.js